import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Stack,
  VStack,
  Text,
  UnorderedList,
  ListItem,
  Link,
} from '@chakra-ui/react'
import React from 'react'

const EventBlueAndWhite2025: React.FC = () => (
  <Box p={4}>
    <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Details
    </Heading>
    <VStack align='start' spacing={4} mb={8}>
      <Text>
        We are back with the second annual fundraiser! Come dressed to impress
        in blue and white!!
      </Text>
      <Text>
        <Text as='span' bg='yellow.200' fontWeight='bold'>
          General event ticket
        </Text>{' '}
        $100 6-10pm - includes food stations, 2 drink tickets (beer/wine/soda),
        silent auction items, photo booth, Five Below Band, Mollie Watson from
        Q102 will emcee, array of desserts by Emersons bakery
      </Text>
      <Text>
        <Text as='span' bg='yellow.200' fontWeight='bold'>
          VIP event ticket
        </Text>{' '}
        $140 5-10pm (limited number available) - includes general event, as well
        as early entry 5-6 pm VIP happy hour with full open bar, passed
        appetizers, silent auction preview
      </Text>
      <Text>
        We are seeking event sponsors as well as donations of items,
        experiences, etc for Silent Auction. For more info visit our facebook
        page, or contact{' '}
        <Link href='mailto:amy@shinelikelauren.org' color='blue.500'>
          Amy Marsh
        </Link>
        {', '}
        <Link href='mailto:tyson@shinelikelauren.org' color='blue.500'>
          Tyson Cobb
        </Link>
        {' or '}
        <Link href='mailto:dan@shinelikelauren.org' color='blue.500'>
          Dan Virzi
        </Link>
      </Text>
      <Text>
        Tickets can be purchased{' '}
        <Link href='https://givebutter.com/c/Wh4B7n' color='blue.500'>
          here.
        </Link>
      </Text>
    </VStack>
    {/* <Divider orientation='horizontal' />
    <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Auction
    </Heading>
    <VStack align='start' spacing={4} mb={8}>
      <Text>
        Don't Miss Out on Our Blue and White Night Auction! From exclusive items
        to unique experiences, our auction has something for everyone. Your
        participation will directly benefit Shine Like Lauren, Inc, helping us
        continue our mission of making a positive impact in our community. Visit
        our{' '}
        <Link
          isExternal
          color='blue.500'
          href='https://givebutter.com/c/SLLBWN/auction'>
          online auction
          <ExternalLinkIcon mx='1px' />
        </Link>{' '}
        now and place your bids. Every contribution counts and brings us one
        step closer to our goals. Thank you for your support and generosity.
      </Text>
    </VStack> */}
    {/* <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Tickets
    </Heading>
    <Box
      as='div'
      dangerouslySetInnerHTML={{
        __html: '<givebutter-widget id="p7AOZL"></givebutter-widget>',
      }}></Box>
    <Divider orientation='horizontal' /> */}
    <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Sponsorship Levels
    </Heading>
    <Stack spacing={4}>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Thoroughbred Sponsor - $800 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company name on website/social media</ListItem>
            <ListItem>Name printed in event pamphlet</ListItem>
            <ListItem>Small company name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              2 General Event Tickets
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Pioneer Sponsor - $1,500 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company name on website/social media</ListItem>
            <ListItem>Name printed in event pamphlet</ListItem>
            <ListItem>Small company name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              4 General Event Tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Wildcat Sponsor - $2,000 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company name/logo on website and social media</ListItem>
            <ListItem>Logo printed in event pamphlet</ListItem>
            <ListItem>Medium company name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              4 VIP Tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Shine Like a Diamond Sponsor - $3,000 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company name/logo on website and social media</ListItem>
            <ListItem>Logo printed in event pamphlet</ListItem>
            <ListItem>Large company name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              6 VIP Tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
    </Stack>
  </Box>
)

export default EventBlueAndWhite2025
